import { render, staticRenderFns } from "./combo-card.vue?vue&type=template&id=1b5a2b39&scoped=true"
import script from "./combo-card.vue?vue&type=script&lang=js"
export * from "./combo-card.vue?vue&type=script&lang=js"
import style0 from "./combo-card.vue?vue&type=style&index=0&id=1b5a2b39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5a2b39",
  null
  
)

export default component.exports